<template>
  <div class="page">
    <app-loader v-if="loader" />
    <div
      v-else-if="car.vin"
      class="page__wrapper pt-5"
    >
      <h3 class="mb-3">
        {{ pageTitle }}
      </h3>
      <v-card
        elevation="1"
        color="blue lighten-5"
        class="mb-6"
      >
        <v-card-text>
          {{ car.vin }}
          <div class="text-transform-none">
            {{ car.model }}, {{ car.color }} <br>
            Место: {{ car.location.storageDescription }}, {{ car.location.siteDescription }}
          </div>
        </v-card-text>
      </v-card>
      <v-autocomplete
        v-model="storage"
        :items="storageList"
        label="Cклад"
        item-text="description"
        class="flex-grow-0 mb-6"
        spellcheck="false"
        return-object
        hide-details
        outlined
        @change="getStorageSiteList"
      />
      <v-autocomplete
        v-model="storageSite"
        :items="storageSiteList"
        :disabled="!storage"
        :loading="storageSiteLoader"
        label="Место хранения"
        item-text="description"
        class="flex-grow-0"
        return-object
        hide-details
        outlined
      />
    </div>
    <div class="page__actions">
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.push('/navigation')"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn
        v-if="storage && storageSite && !acceptLoader"
        color="success"
        x-large
        @click="confirmationModal = true"
      >
        Подтвердить
      </v-btn>
    </div>
    <result-modal
      v-model="resultModal"
      :title="resultModalTitle"
      :text="!error ? car.vin : undefined"
      success
      @close="goToNavigation"
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
    <confirmation-modal
      v-model="confirmationModal"
      @submit="acceptVin"
    />
  </div>
</template>

<script>
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import ResultModal from '@/components/ResultModal.vue';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'MovingCarInWork',
  components: {
    ConfirmationModal,
    ResultModal,
  },
  props: {
    vin: String,
  },
  data: () => ({
    loader: true,
    acceptLoader: false,
    storageSiteLoader: false,
    resultModal: false,
    confirmationModal: false,
    inWork: false,
    noLocation: false,
    error: false,
    car: {},
    storageList: [],
    storageSiteList: [],
    storage: null,
    storageSite: null,
    errorModal: false,
    errorText: '',
  }),
  computed: {
    resultModalTitle() {
      const errorMessage = this.error?.response?.data?.Error?.message;

      if (errorMessage) {
        return errorMessage;
      }

      return 'Автомобиль перемещен';
    },
    interface() {
      return this.car?.operation === 'ПеремещениеНаОтгрузку' ? 'MovementShipping' : 'Moving';
    },
    pageTitle() {
      return this.car?.operation === 'ПеремещениеНаОтгрузку' ? 'Перемещение на отгрузку' : 'Свободное перемещение';
    },
  },
  async created() {
    await this.getCarInfo();
    await this.getStorageList();
    this.loader = false;
  },
  methods: {
    async getCarInfo() {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${this.vin}`).catch((e) => {
        this.onErrorHandler(e);
      });
      this.car = data;
      return Promise.resolve();
    },
    async getStorageList() {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Storages/${this.interface}`).catch((e) => {
        this.onErrorHandler(e);
      });
      this.storageList = data;
      return Promise.resolve();
    },
    async getStorageSiteList() {
      this.storageSite = null;
      this.storageSiteLoader = true;
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/AvailableSites/${this.storage.id}`)
        .catch((e) => {
          this.onErrorHandler(e);
        }).finally(() => {
          this.storageSiteLoader = false;
        });
      this.storageSiteList = data;
    },
    async acceptVin() {
      this.error = false;
      this.acceptLoader = true;
      const params = cloneDeep(this.car);

      params.status = 'ЗаказЗакрыт';
      params.location = {
        storageId: this.storage.id,
        storageDescription: this.storage.description,
        siteId: this.storageSite.id,
        siteDescription: this.storageSite.description,
        ownerId: this.storageSite.ownerId,
        row: this.storageSite.row,
        site: this.storageSite.site,
      };

      await this.$http.post(`MobileOperatorInterface/BasicOperations/Car/${this.car.vin}`, params).then(() => {
        this.resultModal = true;
      }).catch((e) => {
        this.onErrorHandler(e);
      }).finally(() => {
        this.acceptLoader = false;
      });
    },
    goToNavigation() {
      this.$router.push('/navigation');
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>
